import React from "react";
import Carousel from "./ProductCarouselContainer";
import { StandardCarouselModel } from "../Models/PageCreatorPage";

interface Props extends StandardCarouselModel {
  couponCode: string;
}

const StandardCarousel = ({
  productListingUrl,
  title,
  includeShopAllButton,
  shopAllButtonColor,
  products,
  couponCode,
}: Props) => {
  return (
    <Carousel
      displayHeader
      displayShopAllLink={includeShopAllButton}
      headerText={title}
      link={productListingUrl}
      linkColor={shopAllButtonColor}
      items={products}
      discountCode={couponCode}
    />
  );
};

export default StandardCarousel;
